import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/takeUntil';
import { OffboardingImportJob } from '../../models/offboarding.model';
import { OffboardingService } from '../../services/offboarding.service';
import { ASSET } from '../common/employee-assets/asset.constants';
import { assetErrorKey } from '../common/employee-assets/asset.helpers';
import { OFFBOARDING as O } from './offboarding.constants';

@Component({selector: 'app-offboarding-archive-import', templateUrl: './offboarding-archive-import.component.html',
  styleUrls: ['../common/employee-assets/employee-assets.component.css']})
export class OffboardingArchiveImportComponent implements OnInit, OnDestroy {
  @Output() finished = new EventEmitter<void>();
  job: OffboardingImportJob;
  busy = false;
  errorKey = ASSET.empty;
  private polling: Subscription;
  private destroyed = new Subject<void>();
  constructor(private api: OffboardingService) {}
  ngOnInit(): void { this.refresh(); }
  ngOnDestroy(): void { this.stopPolling(); this.destroyed.next(); this.destroyed.complete(); }
  get running(): boolean { return !!this.job && this.job.status === O.importRunning; }
  get completed(): boolean { return !!this.job && this.job.status === O.completed; }
  get failed(): boolean { return !!this.job && this.job.status === O.importFailed; }
  refresh(): void {
    if (this.busy) { return; }
    this.stopPolling(); this.busy = true;
    this.api.importStatus().takeUntil(this.destroyed).subscribe(job => this.receive(job), error => this.fail(error));
  }
  start(): void {
    if (this.busy || !this.job || this.running || this.completed) { return; }
    this.busy = true; this.errorKey = ASSET.empty;
    this.api.importAll().takeUntil(this.destroyed).subscribe(job => this.receive(job), error => this.fail(error));
  }
  private receive(job: OffboardingImportJob): void {
    const wasRunning = this.running;
    this.job = job; this.busy = false; this.errorKey = ASSET.empty;
    if (this.running) { this.monitor(); return; }
    this.stopPolling();
    if (wasRunning) { this.finished.emit(); }
  }
  private monitor(): void {
    if (this.polling && !this.polling.closed) { return; }
    this.polling = Observable.timer(O.importPollMs, O.importPollMs)
      .switchMap(() => this.api.importStatus()).takeUntil(this.destroyed)
      .subscribe(job => this.receive(job), error => this.fail(error));
  }
  private stopPolling(): void { if (this.polling) { this.polling.unsubscribe(); } }
  private fail(error: {status?: number}): void {
    this.stopPolling(); this.busy = false; this.errorKey = assetErrorKey(error, false);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/offboarding/offboarding-archive-import.component.ts